var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.permissions.includes(
      _vm.$store.state.companyData.activeCompany.worker_permission
    )
  )?_c('router-link',{staticClass:"dashboard-sidebar-item",attrs:{"to":_vm.target}},[_c('img',{staticClass:"mr-3 mobile:mr-0",attrs:{"src":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }